module.exports = __webpack_public_path__ + "static/media/2022-mobile-2.9b033186.png";